<template>
  <Layout>
    <div class="relationship" style="height: auto;">
      <div class="right-body">
        <div class="relationship-head">
          <div class="ship-title">{{this.$t('page.product-library.SelectTheProductLibraryBaseType')}}</div>
          <div class="ship-search d-flex">
            <div class="ship-label">
              {{this.$t('page.product-library.DefinitionOfProduct')}}
            </div>
            <div class="search-box d-flex me-5">
              <div class="form-icon search-input">
                <input
                  type="text"
                  class="form-control form-control-icon"
                  id="searchInput"
                  v-model="searchInfo"
                  :placeholder="this.$t('page.product-library.SearchForProductName')"
                />
                <i class="ri-search-line search-icon"></i>
              </div>

              <div class="btn-create">
                <div
                  class="btn btn-primary text-light"
                  @click="handlerJump('create')"
                  v-perm="'model.post'"
                >
                  <i class="ri-add-line align-bottom me-1"></i>
                  {{this.$t('page.product-library.CreateProduct')}}
                </div>
              </div>
              <div class="btn-create">
                <div
                  v-if="showTreeView"
                  class="btn btn-link text-light p-0"
                  @click="handlerJump('cancels')"
                >
                  <img src="../../assets/Primary.png" alt="" />
                </div>
                <div
                  v-else
                  class="btn btn-link text-light p-0"
                  @click="handlerJump('views')"
                >
                  <img src="../../assets/Primary1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="relationship-body d-flex flex-1">
        </div>
      </div>
    </div>
    <div v-show="!showTreeView">
      <div class="relationship">
        <div class="toggle-type">
          <div
            v-for="(type, t_index) in btn_type_list"
            :key="t_index"
            :class="[
              'type-btn',
              t_index == 1 && 'mt-3',
              currentType == t_index + 1 && 'current',
            ]"
            @click="handlerToggle(t_index + 1)"
          >
            <img
              :src="currentType == type.index ? type.d_icon : type.c_icon"
              class="type-icon"
            />
            <div>{{ type.name }}</div>
            <div class="right-icon" v-show="currentType == t_index + 1"></div>
          </div>
        </div>
        <div class="right-body">
          <div class="relationship-head">
          </div>
          <div class="relationship-body d-flex flex-1">
            <div
              :id="'chart' + timeStamp"
              class="shipChart"
              style="width: 100%"
              oncontextmenu="return false;"
            ></div>
            <div class="jump-model" v-show="showBtn" ref="btnModel">
              <div class="btn-style" @click="handlerJump('add')" v-perm="'model.post'">
                <i class="ri-add-circle-fill common-icon"></i>
                <span>{{this.$t('page.product-library.CreateProductsAtThisLevel')}}</span>
              </div>
              <div class="btn-style my-1" @click="handlerJump('view')" v-perm="'model.get'">
                <i class="ri-eye-fill common-icon"></i>
                <span>{{this.$t('page.product-library.ViewDetails')}}</span>
              </div>
              <div class="btn-style" @click="handlerJump('cancel')">
                <i class="ri-close-circle-fill common-icon"></i>
                <span>{{this.$t('base.cancel')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas offcanvas-end border-0" style="max-height: 1000px; top: 140px" tabindex="-1" id="theme-settings-offcanvas">
      <div class="offcanvas-body p-0">
        <SimpleBar class="h-100">
          <div class="p-4">
            <viewDetail
              v-model:showDetail="showDetail"
              :currentNode="currentNode"
              :currentType="currentType"
              @initChartData="initChartData"
              ref="modelChild"
            ></viewDetail>
          </div>
        </SimpleBar>
      </div>
    </div>
    <div
      class="treeMode"
      v-show="showTreeView"
    >
      <treeView
        v-model:showDetail="showTreeView"
        :currentNode="currentNode"
        :currentType="currentType"
        @initChartData="initChartData"
        ref="modelChild"
      ></treeView>
    </div>

    <button ref="viewDetailBtn" class="btn-info btn-rounded shadow-lg btn btn-icon btn-lg p-2" style="display: none" data-bs-toggle="offcanvas" data-bs-target="#theme-settings-offcanvas" aria-controls="theme-settings-offcanvas">
    </button>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import { modelBaseChart1 } from "@/utils/chart.js";
import { getModelList } from "@/service/index";
import { getUseModel, setChartData } from "@/utils/filterModel.js";
import treeView from "./tree/index.vue";
import viewDetail from "./components/detail.vue";
import { SimpleBar } from "simplebar-vue3";
import _ from "lodash";
export default {
  data() {
    return {
      searchInfo: "",
      showBtn: false,
      timeStamp: +new Date(),
      currentClick: "",
      relationShipList: [],
      oldRelationShipList: [],
      currentNode: null,
      showDetail: false,
      btn_type_list: [
        {
          d_icon: require("@/assets/泵头.svg"),
          c_icon: require("@/assets/泵头c.svg"),
          index: 1,
          name: this.$t('page.work-order.device.single'),
        },
        {
          d_icon: require("@/assets/机组.svg"),
          c_icon: require("@/assets/机组c.svg"),
          index: 2,
          name: this.$t('page.work-order.device.unit_type'),
        },
      ],
      currentType: 1,
      originalData: [],
      oldSearchInfo: "",
      showTreeView: false,
    };
  },
  computed: {
    setChartStyle() {
      let style = {
        width: this.relationShipList.length == 1 ? "100%" : "calc(50% - 10px)",
        height:
          this.relationShipList.length == 1 ? "calc(100vh - 520px)" : "50vh",
      };
      return style;
    },
  },
  mounted() {
    document.onkeydown = function () {
      if (event.ctrlKey && window.event.keyCode == 67) {
        return false;
      }
    };
    sessionStorage.removeItem("parentNodes");
    this.initChartData();
    window.addEventListener("keydown", this.enterEvent());
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.enterEvent());
    document
      .getElementsByTagName("body")[0]
      .classList.remove("overflow-hidden");
    document
      .getElementsByTagName("body")[0].style=""
  },
  methods: {
    handlerToggle(index) {
      this.currentType = index;
      this.showBtn = false;
      this.initChartData();
    },
    async initChartData() {
      this.relationShipList = [];
      await getModelList({ type: this.currentType })
        .then((res) => {
          if (res && res.payload && res.payload.data) {
            this.originalData = _.cloneDeep(res.payload.data)
            let shipList = getUseModel(res.payload.data);
            shipList.forEach((ship) => {
              let { nodes, links, categories } = setChartData(ship);
              this.relationShipList.push({
                nodes: nodes,
                links: links,
                categories: categories,
                color: ship.extra_info.color,
              });
            });
            this.oldRelationShipList = _.cloneDeep(this.relationShipList);
          this.timeStamp = +new Date();
          this.$nextTick(() => {
            this.initCharts();
          });
          }
        })
      
    },

    initCharts(selectNode) {
      /* 方式一 */
      // this.relationShipList.forEach((ship, index) => {
      //   let chartDom = document.querySelector(
      //     `#chart${index}${this.timeStamp}`
      //   );
      //   let options = {
      //     chartDom: chartDom,
      //     data: ship,
      //   };
      //   modelBaseChart(options, this.showBtnList, selectNode);
      // });

      /* 方式二 */
      let chartDom = document.querySelector(`#chart${this.timeStamp}`);
      let options = {
        chartDom,
        data: this.relationShipList,
      };
      modelBaseChart1(options, this.showBtnList, selectNode);
    },
    showBtnList(options) {
      this.showBtn = false;
      this.currentNode = options.node;
      if (options.name == this.currentClick) {
        this.showBtn = !this.showBtn;
        this.currentClick = options.name;
      } else {
        this.currentClick = options.name;
        this.showBtn = true;
      }
      let dom = this.$refs.btnModel;
      dom.style.left = `${options.x + 15}px`;
      dom.style.top = `${options.y + 15}px`;
    },
    enterEvent() {
      document.onkeydown = (e) => {
        if (document.querySelector("#searchInput")) {
          if (e.keyCode == 13 && e.target.baseURI.match(/model/)) {
            this.searchNodeName();
          }
        }
      };
    },
    findNode(nodes, keyword) {
      let result = []
      for(var i = 0;i < nodes.length; i++) {
          let temp = nodes[i]
          if (temp.name.toLowerCase().indexOf(temp.name.toLowerCase()) !== -1){
              if (temp.children && temp.children.length > 0) {
                  temp.children = this.findNode(temp.children, keyword)
              }
              result.push(temp)
          }
          else {
              if (temp.children && temp.children.length > 0) {
                  let tempNode = this.findNode(temp.children, keyword)
      
                  if (tempNode && tempNode.length > 0){
                      temp.children = tempNode
                      result.push(temp)
                  }
              }
          }
      }
      return result
    },
    searchNodeName() {
      if (this.searchInfo == this.oldSearchInfo){
        return
      } else {
        this.oldSearchInfo = this.searchInfo
      }
      this.relationShipList = [];
      this.$refs.modelChild.searchThree(this.searchInfo);
      if (this.searchInfo) {
        // let filterInfo = [];
        // let cateName = "";
        let result = this.findNode(_.cloneDeep(this.originalData), this.searchInfo)
        result.forEach((ship) => {
          let { nodes, links, categories } = setChartData(ship);
          this.relationShipList.push({
            nodes: nodes,
            links: links,
            categories: categories,
            color: ship.extra_info.color,
          });
        });
        // this.relationShipList.forEach((ship) => {
        //   cateName = "";
        //   ship.categories.forEach((cate, i) => {
        //     cateName += cate.name;
        //     if (
        //       i == ship.categories.length - 1 &&
        //       cateName.indexOf(this.searchInfo) > -1
        //     ) {
        //       console.log(cateName);
        //       filterInfo.push(ship);
        //       return;
        //     }
        //   });
        // });
        // this.relationShipList = filterInfo;
      } else {
        this.relationShipList = this.oldRelationShipList
      }
      // console.log(this.searchInfo);
      this.timeStamp = +new Date();
      this.$nextTick(() => {
        this.initCharts(this.searchInfo);
      });
    },
    handlerJump(type) {
      switch (type) {
        case "create":
          this.$router.push({
            path: "/model/form",
            query: {
              type: "create",
              title: this.$t('page.product-library.NewProduct'),
              current_type: this.currentType,
            },
          });
          break;
        case "add":
          sessionStorage.setItem(
            "parentNodes",
            JSON.stringify(this.currentNode.parentNode)
          );
          this.$router.push({
            path: "/model/form",
            query: {
              type: "add",
              model_id: this.currentNode.id,
              current_type: this.currentType,
              title: this.$t('page.product-library.NewProduct'),
            },
          });
          break;
        case "view":
          if (this.currentNode.level && this.currentNode.level != 1) {
            sessionStorage.setItem(
              "parentNodes",
              JSON.stringify(this.currentNode.parentNode)
            );
          } else {
            sessionStorage.setItem("parentNodes", JSON.stringify([null]));
          }
          this.$refs.viewDetailBtn.click()
          // this.showDetail = true;
          // document.getElementsByTagName("body")[0].classList.add("overflow-hidden");
          // document.getElementById("scrollBox").style.background = "#FFFFFF00";
          // document.getElementById("leftCard").style.opacity = 0;
          // document.getElementById("leftCard").style.pointerEvents = "none";
          // document.getElementsByClassName("rightCard")[0].style.background =
          //   "#ffffff";
          this.showBtn = false;
          break;
        case "views":
          this.currentNode = _.get(this.relationShipList, [0, "nodes", 0]);
          if (this.currentNode&&this.currentNode.level && this.currentNode.level != 1) {
            sessionStorage.setItem(
              "parentNodes",
              JSON.stringify(this.currentNode.parentNode)
            );
          } else {
            sessionStorage.setItem("parentNodes", JSON.stringify([null]));
          }
          this.showTreeView = true;
          document.getElementsByTagName("body")[0].classList.add("overflow-hidden");
          // document.getElementById("scrollBox").style.background = "#f3f6f9";
          // document.getElementById("leftCard").style.opacity = 1;
          // document.getElementById("leftCard").style.pointerEvents = "auto";
          // document.getElementsByClassName("rightCard")[0].style.background =
          //   "#ffffff00";

          this.showBtn = false;
          break;
        case "cancels":
          this.showTreeView = false;
          document.getElementsByTagName("body")[0].classList.remove("overflow-hidden");
          this.showBtn = false;
          break;
        case "cancel":
          this.showBtn = !this.showBtn;
          break;
      }
    },
  },
  components: {
    Layout,
    treeView,
    viewDetail,
    SimpleBar,
  },
};
</script>

<style scoped lang="scss">
.relationship {
  height: calc(100vh - 269px);
  display: flex;
}

.toggle-type {
  margin-top: 10rem;
  .type-btn {
    position: relative;
    padding: 20px 40px;
    border-radius: 4px;
    background-color: #e9ebec;
    display: flex;
    flex-flow: column;
    align-items: center;
    .type-icon {
      width: 20px;
      height: 20px;
      margin-bottom: 8px;
    }

    .right-icon {
      position: absolute;
      top: 50%;
      right: -10px;
      transform: translateY(-50%);
      border-style: solid;
      border-color: transparent;
      border-width: 10px 0 10px 10px;
      border-left-color: #6691e7;
    }

    &:hover {
      cursor: pointer;
    }
    &.current {
      color: #fff;
      background-color: #6691e7;
    }
  }
}

.right-body {
  flex: 1;
  margin-left: 30px;
  display: flex;
  flex-flow: column;
  .relationship-head {
    color: #495057;
    .ship-title {
      font-size: 20px;
    }
    .ship-search {
      font-size: 14px;
      color: #878a99;
      align-items: center;
      justify-content: space-between;
      .search-input {
        min-width: 300px;
      }
      .btn-create {
        margin-left: 20px;
      }
    }
  }
  .relationship-body {
    flex-wrap: wrap;
    flex: 1;
    .shipChart {
      margin-bottom: 20px;
      &:nth-of-type(odd) {
        margin-right: 10px;
      }
      &:nth-of-type(even) {
        margin-left: 10px;
      }
    }
    .jump-model {
      position: absolute;
      background-color: #fff;
      padding: 10px;
      border-radius: 5px;
      .btn-style {
        display: flex;
        align-items: center;
        .common-icon {
          color: #6691e7;
          margin-right: 5px;
        }
        &:hover {
          cursor: pointer;
          background-color: #f3f6f9;
        }
      }
    }
  }
}
.treeMode {
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  //   background: rgba(0, 0, 0, 0.2);
  z-index: 1050;
}
#staticBackdrop {
  display: none !important;
}
.offcanvas-end {
  width: 75%;
}
</style>
